import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const themeSettingsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-insight-global-configuration-theme-settings" */ './main.tsx'
			),
	),
	getPreloadProps: () => ({}),
});
